var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { attrs: { fluid: "" } }, [
    _c(
      "div",
      { staticClass: "d-flex justify-center" },
      [
        _c("v-img", {
          attrs: {
            "max-width": "240",
            src: require("@/assets/img/sentiment_very_dissatisfied.png")
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "d-flex justify-center" }, [
      _c("h1", { staticClass: "display-4 font-weight-black black--text" }, [
        _vm._v(" 404 ")
      ])
    ]),
    _c("div", { staticClass: "d-flex justify-center" }, [
      _c("h2", { staticClass: "headline black--text" }, [
        _vm._v(" Página não encontrada. ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }